export default __webpack_public_path__ + "static/media/error-bg.4f5ecab2.png";